import { timelineStory } from "@/mocks/gua";

export default function StoryTimeline() {
  return (
    <section id="story" className="mt-16 scroll-mt-24 px-4 md:mt-24 md:px-6">
      <div className="mx-auto max-w-[1240px] overflow-hidden rounded-xl bg-background-950">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* 左图 */}
          <div className="relative min-h-[260px] lg:min-h-full">
            <img
              src={timelineStory.img}
              alt={`${timelineStory.title} 片场时间线配图`}
              className="absolute inset-0 h-full w-full object-cover object-top opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent lg:bg-gradient-to-r" />
            <div className="relative z-10 flex h-full flex-col justify-end gap-3 p-5 md:p-8">
              <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-history-line" /> {timelineStory.tag}
              </span>
              <h2 className="font-heading text-xl font-bold leading-snug text-white md:text-2xl">
                {timelineStory.title}
              </h2>
              <p className="max-w-md text-sm leading-relaxed text-white/80">{timelineStory.intro}</p>
              <div className="mt-2 flex flex-wrap gap-2">
                {timelineStory.bottom.map((b) => (
                  <span key={b.label} className="whitespace-nowrap rounded bg-white/10 px-3 py-1.5 text-xs text-white/85 backdrop-blur">
                    <span className="text-white/50">{b.label}：</span>
                    {b.value}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* 右时间线 */}
          <div className="relative p-5 md:p-8">
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-500/50 to-transparent" />
            <div className="relative flex flex-col gap-0">
              <div className="absolute bottom-2 left-[13px] top-2 w-px bg-background-700" />
              {timelineStory.phases.map((p, i) => (
                <div key={p.time} className="relative flex gap-4 pb-6 last:pb-0">
                  <span
                    className={`relative z-10 mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs text-background-50 ${
                      i === timelineStory.phases.length - 1 ? "bg-accent-500" : "bg-primary-500"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="flex-1 pt-0.5">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className={`text-xs font-semibold ${i === timelineStory.phases.length - 1 ? "text-accent-400" : "text-primary-400"}`}>
                        {p.time}
                      </span>
                      <h3 className="text-sm font-semibold text-white">{p.title}</h3>
                    </div>
                    <p className="mt-1.5 text-xs leading-relaxed text-white/70 md:text-sm">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}